<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>
      <Sidebar></Sidebar>
      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Create Partner</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="form_wrapper_inner">
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Name</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model.trim="$v.title.$model"
                        :class="{'is-invalid': validationStatus($v.title)}"
                        class="form-control form-control-lg"
                      />
                      <div v-if="!$v.title.required" class="invalid-feedback">
                        The title field is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Logo</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValue.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValue"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageData!=null">
                          <img class="preview" :src="picture" />

                          <button @click="onUpload">Upload</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- hero image -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Hero Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagech"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuech.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuech"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatach!=null">
                          <img class="preview" :src="picturech" />

                          <button @click="onUploadch">Upload</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End of the hero image -->
                  <!-- social icon -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Facebook url</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model.trim="$v.facebook.$model"
                        :class="{'is-invalid': validationStatus($v.facebook)}"
                        class="form-control form-control-lg"
                      />
                      <div
                        v-if="!$v.facebook.required"
                        class="invalid-feedback"
                      >
                        The facebook url field is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">instagram url</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model.trim="$v.instagram.$model"
                        :class="{'is-invalid': validationStatus($v.instagram)}"
                        class="form-control form-control-lg"
                      />
                      <div
                        v-if="!$v.instagram.required"
                        class="invalid-feedback"
                      >
                        The instagram url field is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Twiter url</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model.trim="$v.twiter.$model"
                        :class="{'is-invalid': validationStatus($v.twiter)}"
                        class="form-control form-control-lg"
                      />
                      <div v-if="!$v.twiter.required" class="invalid-feedback">
                        The twiter url field is required.
                      </div>
                    </div>
                  </div>
                  <!-- End social icon -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Status</label>
                    <div class="col-md-12 border-bottom p-0">
                      <select
                        name="type"
                        v-model="type"
                        :class="{'is-invalid': validationStatus($v.type)}"
                        class="form-control"
                      >
                        <option selected value="1">Publish</option>
                        <option value="0">UnPublish</option>
                      </select>
                      <div v-if="!$v.type.required" class="invalid-feedback">
                        The type field is required.
                      </div>
                      <!-- <span>Selected: {{ type }}</span>--->
                    </div>
                  </div>
                  <!---- second section ----><span>second section</span>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagechssi"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuechssi.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuechssi"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatachssi!=null">
                          <img class="preview" :src="picturechssi" />

                          <button @click="onUploadchssi">Upload</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">About </label>
                    <div class="col-md-12 border-bottom p-0">
                      <textarea
                        v-model.trim="$v.about.$model"
                        :class="{'is-invalid': validationStatus($v.about)}"
                        class="form-control form-control-lg"
                        rows="2"
                      ></textarea>
                      <div v-if="!$v.about.required" class="invalid-feedback">
                        The about required.
                      </div>
                    </div>
                  </div>
                 <span>Third section</span>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0"
                      >Upload Hero image for third section</label
                    >
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagechssitsi"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuechssitsi.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuechssitsi"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatachssitsi!=null">
                          <img class="preview" :src="picturechssitsi" />

                          <button @click="onUploadchssitsi">Upload</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Email</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model.trim="$v.email.$model"
                        :class="{'is-invalid': validationStatus($v.email)}"
                        class="form-control form-control-lg"
                      />
                      <div v-if="!$v.email.required" class="invalid-feedback">
                        The email field is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Phone</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model.trim="$v.phone.$model"
                        :class="{'is-invalid': validationStatus($v.phone)}"
                        class="form-control form-control-lg"
                      />
                      <div v-if="!$v.phone.required" class="invalid-feedback">
                        The phone field is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Address</label>
                    <div class="col-md-12 border-bottom p-0">
                      <textarea
                        v-model.trim="$v.address.$model"
                        :class="{'is-invalid': validationStatus($v.address)}"
                        class="form-control form-control-lg"
                        rows="5"
                      ></textarea>
                      <div v-if="!$v.address.required" class="invalid-feedback">
                        The Address field is required.
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4 openinghours">
                  <label class="col-md-12 p-0">Opening Hours</label>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input type="text" class="form-control form-control-lg"  value="sunday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input
                            type="text"
                            v-model.trim="$v.sunday.$model"
                            :class="{'is-invalid': validationStatus($v.sunday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.sunday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input type="text" class="form-control form-control-lg"  value="monday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input
                            type="text"
                            v-model.trim="$v.monday.$model"
                            :class="{'is-invalid': validationStatus($v.monday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.monday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input type="text" class="form-control form-control-lg"  value="Tuesday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input 
                            type="text"
                            v-model.trim="$v.tuesday.$model"
                            :class="{'is-invalid': validationStatus($v.tuesday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.tuesday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input class="form-control form-control-lg"  type="text" value="Wednesday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input
                            type="text"
                            v-model.trim="$v.wednesday.$model"
                            :class="{'is-invalid': validationStatus($v.wednesday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.wednesday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input class="form-control form-control-lg" type="text" value="Thursday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input
                            type="text"
                            v-model.trim="$v.thursday.$model"
                            :class="{'is-invalid': validationStatus($v.thursday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.thursday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input class="form-control form-control-lg" type="text" value="Friday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input
                            type="text"
                            v-model.trim="$v.friday.$model"
                            :class="{'is-invalid': validationStatus($v.friday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.friday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                  <div class="col-md-12">
                      <div class="col-md-6 border-bottom p-0">
                        <input class="form-control form-control-lg" type="text" value="Saturday" readonly>
                      </div>
                      <div class="col-md-6 border-bottom p-0">
                        <input
                            type="text"
                            v-model.trim="$v.saturday.$model"
                            :class="{'is-invalid': validationStatus($v.saturday)}"
                            class="form-control form-control-lg"
                            />
                        <div v-if="!$v.saturday.required" class="invalid-feedback">
                            The field is required.
                        </div>
                      </div>
                  </div>
                </div>
               
                  <div class="card profile-card">
                    <div class="card-body">
                      <div class="form-group mb-4">
                        <label class="col-md-12 p-0">Meta Title</label>
                        <div class="col-md-12 border-bottom p-0">
                          <input
                            type="text"
                            v-model.trim="$v.meta_title.$model"
                            :class="{'is-invalid': validationStatus($v.meta_title)}"
                            class="form-control form-control-lg"
                          />
                          <div
                            v-if="!$v.meta_title.required"
                            class="invalid-feedback"
                          >
                            The meta title field is required.
                          </div>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <label class="col-md-12 p-0">Meta Description</label>
                        <div class="col-md-12 border-bottom p-0">
                          <textarea
                            v-model.trim="$v.meta_description.$model"
                            :class="{'is-invalid': validationStatus($v.meta_description)}"
                            class="form-control form-control-lg"
                            rows="5"
                          ></textarea>
                          <div
                            v-if="!$v.meta_description.required"
                            class="invalid-feedback"
                          >
                            The meta description field is required.
                          </div>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <label class="col-md-12 p-0">Meta Keywords</label>
                        <div class="col-md-12 border-bottom p-0">
                          <input
                            type="text"
                            v-model.trim="$v.meta_keywords.$model"
                            :class="{'is-invalid': validationStatus($v.meta_keywords)}"
                            class="form-control form-control-lg"
                          />
                          <div
                            v-if="!$v.meta_keywords.required"
                            class="invalid-feedback"
                          >
                            The meta keywords field is required.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-4 submit_btn_wrapper">
                      <div class="col-sm-12 pl-0 mt-10">
                        <input
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </body>
</template>
<script>
import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import firebase from 'firebase';
import {
	required
}
from 'vuelidate/lib/validators'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
	db
}
from '../../main'
Vue.use(VueAxios, axios)
export default {
	name: 'Create',
	components: {
		'Header': Header,
		'Sidebar': Sidebar,
		'Footer': Footer,
	},
	data: function() {
		return {
			selected: '',
			slugurl: '',
			options: [],
			imageData: null,
			picture: null,
			uploadValue: 0,
			imageDatach: null,
			picturech: null,
			uploadValuech: 0,
			imageDatachssi: null,
			picturechssi: null,
			uploadValuechssi: 0,
			imageDatachssitsi: null,
			picturechssitsi: null,
			uploadValuechssitsi: 0,
			type: null,
			ohours: '',
			email: '',
			phone: '',
			address: '',
			title: '',
			about: '',
			facebook: '',
			instagram: '',
			twiter: '',
			meta_title: '',
			meta_description: '',
			meta_keywords: '',
      sunday: '',
      monday: '',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: '',
      saturday: '',
			editor: ClassicEditor,
			editorData: '<p>Content of the editor.</p>',
			editorConfig: {
				// The configuration of the editor.
			}
		}
	},
	created: function() {},
	validations: {
		title: {
			required
		},
		facebook: {
			required
		},
		address: {
			required
		},
		twiter: {
			required
		},
		instagram: {
			required
		},
		about: {
			required
		},
		email: {
			required
		},
		phone: {
			required
		},
		sunday: {
			required
		},
    monday: {
			required
		},
    tuesday: {
			required
		},
  wednesday: {
			required
		},
	thursday: {
			required
		},
	friday: {
			required
		},
  saturday: {
			required
		},
		type: {
			required
		},
		meta_title: {},
		meta_description: {},
		meta_keywords: {}
	},
	methods: {

		previewImage(event) {
				this.uploadValue = 0;
				this.picture = null;
				this.imageData = event.target.files[0];
				console.log(this.imageData);
			},
			onUpload() {
				this.picture = null;
      // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageData.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRef = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageData);
				storageRef.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValue = 100;
					storageRef.snapshot.ref.getDownloadURL().then((url) => {
						this.picture = url;
            //alert(this.picture);
					});
				});
			},
			previewImagech(eventch) {
				this.uploadValuech = 0;
				this.picturech = null;
				this.imageDatach = eventch.target.files[0];
			},
			onUploadch() {
				this.picturech = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatach.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRefch = firebase.storage().ref(this.imagename+makeid(5)+"."+imageextension).put(this.imageDatach);
				storageRefch.on('state_changed', snapshot => {
					this.uploadValuech = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuech = 100;
					storageRefch.snapshot.ref.getDownloadURL().then((url) => {
						this.picturech = url;
					});
				});
			},
			previewImagechssi(eventchssi) {
				this.uploadValuechssi = 0;
				this.picturechssi = null;
				this.imageDatachssi = eventchssi.target.files[0];
			},
			onUploadchssi() {
				this.picturechssi = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatachssi.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRefchssi = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageDatachssi);
				storageRefchssi.on('state_changed', snapshot => {
					this.uploadValuechssi = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuechssi = 100;
					storageRefchssi.snapshot.ref.getDownloadURL().then((url) => {
						this.picturechssi = url;
					});
				});
			},
			previewImagechssitsi(eventchssitsi) {
				this.uploadValuechssitsi = 0;
				this.picturechssitsi = null;
				this.imageDatachssitsi = eventchssitsi.target.files[0];
			},
			onUploadchssitsi() {
				this.picturechssitsi = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatachssitsi.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRefchssitsi = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageDatachssitsi);
				storageRefchssitsi.on('state_changed', snapshot => {
					this.uploadValuechssitsi = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuechssitsi = 100;
					storageRefchssitsi.snapshot.ref.getDownloadURL().then((url) => {
						this.picturechssitsi = url;
					});
				});
			},
			validationStatus: function(validation) {
				return typeof validation != "undefined" ? validation.$error : false;
			},
			submit: function() {
			//alert(this.picture);
			var theSlug = this.title;
				theSlug = theSlug.toLowerCase();
				theSlug = theSlug.replace(/\s+/g, '-');
				// Replace Ampersand With Dash and Spaces
			theSlug = theSlug.replace(/&/g, "-and-")
				this.slugurl = theSlug;

				this.$v.$touch();
				if(this.$v.$pendding || this.$v.$error) return;
				var date = new Date().toLocaleString();
				db.collection("partner").add({
					title: this.title,
					slugurl: this.slugurl,
					facebook: this.facebook,
					instagram: this.instagram,
					twiter: this.twiter,
					email: this.email,
					about: this.about,
					address: this.address,
					phone: this.phone,
					sunday: this.sunday,
          monday: this.monday,
          tuesday: this.tuesday,
          wednesday: this.wednesday,
          thursday: this.thursday,
          friday: this.friday,
          saturday: this.saturday,
					companylogo: this.picture,
					companyheroimage: this.picturech,
					secondsectionimage: this.picturechssi,
					thirdsectionimage: this.picturechssitsi,
					type:parseInt(this.type),
					meta_title: this.meta_title,
					meta_description: this.meta_description,
					meta_keywords: this.meta_keywords,
					created: date,
					modified: date,
				}).then(() => {
					console.log("Added Successfully!");
					this.$toasted.success('Success, Added Successfully!', {
						icon: 'check',
						//icon : 'error_outline'
					})
					this.$router.push('/partner/index');
				}).catch((error) => {
					console.error("Error writing document: ", error);
				});
			}
	}
}
</script>
<style>
form.form-horizontal.form-material {
  max-height: 90vh;
  overflow-y: scroll;
}
form.form-horizontal.form-material::-webkit-scrollbar {
  width: 10px;
}
form.form-horizontal.form-material::-webkit-scrollbar-track {
  background: #e5e5e5;
}

/* Handle */
form.form-horizontal.form-material::-webkit-scrollbar-thumb {
  background: #03e1bc;
}

/* Handle on hover */
form.form-horizontal.form-material::-webkit-scrollbar-thumb:hover {
  background: #03e1bcc4;
}
.formcta_wrapper div:nth-child(2) p {
  display: flex;
  margin-top: 12px;
  align-items: center;
}

.formcta_wrapper .preview {
  max-width: 150px;
}
.formcta_wrapper div:nth-child(2) p #progress {
  margin-left: 10px;
}
.formcta_wrapper button {
  display: block;
  border: none;
  background: #03e1bc;
  padding: 2px 20px;
  font-size: 12px;
  border-radius: 15px;
  margin-top: 10px;
  color: #fff;
}
.submit_btn_wrapper {
  padding-bottom: 40px;
  padding-left: 20px;
}

.openinghours > div {
    display: flex;
    align-items: center;
}

.openinghours > div > div {
    padding: 10px !important;
}
</style>
